import React, { useEffect } from 'react';
import Header from '../../components/Header/Header';
import { WhistleblowerForm } from '../../components/Forms/WhistleblowerForm';
import { Info } from 'lucide-react';
import './Denuncia.css';
import { useTranslation } from "react-i18next";
import { PageSeo } from '../../seo/Seo';

export default function Denuncia() {
    const { t } = useTranslation();

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="denuncia-page">
            <PageSeo page="denuncia" path="/canal-de-denuncias" />
            <Header />

            <div className="denuncia-container">

                {/* Hero Section */}
                <div className="denuncia-hero">
                    <div className="denuncia-hero-content">
                        <p className="denuncia-hero-text">
                            {t('denuncia.hero_text', 'A Calriz reitera que integridade e respeito são inegociáveis e utiliza o Canal de Denúncias como uma ferramenta essencial para garantir um ambiente de trabalho ético, seguro e respeitoso.')}
                        </p>
                    </div>
                </div>

                {/* Info Text */}
                <div className="denuncia-info-box">
                    <p className="denuncia-info-text">
                        {t('denuncia.info_p1', 'Nuestra principal preocupación é eliminar a omissão, oferecendo a você um meio confidencial para reportar situações que violem nossos valores, como assédio, discriminação e outras irregularidades.')}
                    </p>
                    <p className="denuncia-info-text">
                        {t('denuncia.info_p2', 'Sua denúncia permite que a empresa atue de forma rápida e responsável, proteja o bem-estar de todos e fortaleça a confiança e a transparência em nossos processos.')}
                    </p>
                    <div className="denuncia-highlight">
                        <Info size={24} />
                        <p>
                            {t('denuncia.highlight', 'Você é um guardião ativo da nossa cultura. Utilize o Canal de Denúncias e confie no processo para manter a Calriz um ambiente justo, íntegro e respeitoso.')}
                        </p>
                    </div>
                </div>

                {/* Form */}
                <WhistleblowerForm />

                {/* Tipos de Denúncias */}
                <div className="denuncia-types-box">
                    <h3 className="denuncia-types-title">{t('denuncia.types_title', 'Tipos de denúncias que podem ser registradas:')}</h3>

                    <div className="denuncia-types-list">
                        {/* Assédio Moral */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.moral_harassment', 'Assédio Moral')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_moral_p', 'Condutas abusivas, repetitivas ou não, que exponham o colaborador a situações humilhantes, constrangedoras ou que afetem sua dignidade, desempenho ou saúde emocional no ambiente de trabalho.')}
                            </p>
                        </div>

                        {/* Assédio Sexual */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.sexual_harassment', 'Assédio Sexual')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_sexual_p', 'Qualquer comportamento de cunho sexual indesejado, como insinuações, comentários, gestos, contatos físicos ou pedidos que causem constrangimento, intimidação ou desconforto.')}
                            </p>
                        </div>

                        {/* Discriminação */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.discrimination', 'Discriminação')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_disc_p', 'Tratamento desigual ou preconceituoso baseado em raça, cor, gênero, idade, religião, orientação sexual, deficiência, origem ou qualquer outra condição protegida por lei.')}
                            </p>
                        </div>

                        {/* Fraude */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.fraud', 'Fraude')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_fraud_p', 'Atos intencionais para obter vantagem indevida, como falsificação de documentos, manipulação de informações, desvio de recursos ou qualquer prática desonesta que cause prejuízo à empresa ou a terceiros.')}
                            </p>
                        </div>

                        {/* Conflito de Interesses */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.conflict_of_interest', 'Conflito de Interesses')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_conflict_p', 'Situações em que interesses pessoais, familiares ou externos possam influenciar ou comprometer decisões profissionais, a imparcialidade ou os interesses da Calriz.')}
                            </p>
                        </div>

                        {/* Violação do Código de Ética */}
                        <div className="denuncia-type-item">
                            <h4 className="denuncia-type-title">• {t('forms.whistleblower.types.ethics_violation', 'Violação do Código de Ética')}</h4>
                            <p className="denuncia-type-desc">
                                {t('denuncia.type_ethics_p', 'Qualquer conduta que desrespeite as normas, valores, políticas internas e princípios éticos estabelecidos pela empresa.')}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
